import { render } from "./Styles.vue?vue&type=template&id=6f6ab60c"
import script from "./Styles.vue?vue&type=script&lang=js"
export * from "./Styles.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hrko/_HACKERSANDDESIGNERS/Code/chatty-latest/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__